import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FullPageWithCenterContentV2 from "../container/FullPageWithCenterContentV2";
import { theme } from "../../styles/theme";
import { Box, CircularProgress } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { webTestTypeAtom } from "../../recoil/webTestTypeAtom";
import { useOnboardingProgress } from "../../hooks/useOnboardingProgress";
import ProductContentPromotion from "../../components/task/payment/ProductContentPromotion";
import Motivation_8_Promotion from "./partPromotion/motivation/Motivation_8_Promotion";
import Start_1_Promotion from "./partPromotion/acquisition/Start_1_Promotion";
import Demographic_1_Promotion from "./partPromotion/demographic/Demographic_1_Promotion";
import Demographic_2_Promotion from "./partPromotion/demographic/Demographic_2_Promotion";
import Demographic_3_Promotion from "./partPromotion/demographic/Demographic_3_Promotion";
import Demographic_4_Promotion from "./partPromotion/demographic/Demographic_4_Promotion";
import Goal_1_Promotion from "./partPromotion/goal/Goal_1_Promotion";
import Goal_2_MultiSelect_1_Promotion from "./partPromotion/goal/Goal_2_MultiSelect_1_Promotion";
import Goal_3_MultiSelect_2_Promotion from "./partPromotion/goal/Goal_3_MultiSelect_2_Promotion";
import Goal_4_Promotion from "./partPromotion/goal/Goal_4_Promotion";
import Goal_5_Promotion from "./partPromotion/goal/Goal_5_Promotion";
import Goal_6_Promotion from "./partPromotion/goal/Goal_6_Promotion";
import Goal_7_Promotion from "./partPromotion/goal/Goal_7_Promotion";
import Goal_8_Promotion from "./partPromotion/goal/Goal_8_Promotion";
import Goal_9_Promotion from "./partPromotion/goal/Goal_9_Promotion";
import Goal_10_Promotion from "./partPromotion/goal/Goal_10_Promotion";
import Goal_11_Promotion from "./partPromotion/goal/Goal_11_Promotion";
import Convention_1_Promotion from "./partPromotion/convention/Convention_1_Promotion";
import Convention_2_QnA_Promotion from "./partPromotion/convention/Convention_2_QnA_Promotion";
import Habit_1_Promotion from "./partPromotion/habit/Habit_1_Promotion";
import Habit_2_QnA_Promotion from "./partPromotion/habit/Habit_2_QnA_Promotion";
import Habit_3_Promotion from "./partPromotion/habit/Habit_3_Promotion";
import Habit_4_Promotion from "./partPromotion/habit/Habit_4_Promotion";
import Habit_5_Promotion from "./partPromotion/habit/Habit_5_Promotion";
import Habit_6_Promotion from "./partPromotion/habit/Habit_6_Promotion";
import Habit_7_Promotion from "./partPromotion/habit/Habit_7_Promotion";
import Motivation_1_Promotion from "./partPromotion/motivation/Motivation_1_Promotion";
import Motivation_2_Promotion from "./partPromotion/motivation/Motivation_2_Promotion";
import Motivation_3_Promotion from "./partPromotion/motivation/Motivation_3_Promotion";
import Motivation_4_Promotion from "./partPromotion/motivation/Motivation_4_Promotion";
import Motivation_5_Promotion from "./partPromotion/motivation/Motivation_5_Promotion";
import Motivation_6_Promotion from "./partPromotion/motivation/Motivation_6_Promotion";
import Motivation_7_MultiSelect_Promotion from "./partPromotion/motivation/Motivation_7_MultiSelect_Promotion";
import Result_1_Promotion from "./partPromotion/result/Result_1_Promotion";
import Result_2_Promotion from "./partPromotion/result/Result_2_Promotion";
import Result_3_Promotion from "./partPromotion/result/Result_3_Promotion";
import Result_4_Promotion from "./partPromotion/result/Result_4_Promotion";
import Convention_3_Promotion from "./partPromotion/convention/Convention_3_Promotion";
import Goal_12_Promotion from "./partPromotion/goal/Goal_12_Promotion";
import useMixpanelMKT from "../../hooks/useMixpanelMKT";
import {
  readLastStep,
  writeLastStep,
} from "../../utils/promotionOnboardingStorage";
import { usePrevious } from "../../hooks/usePrevious";
import Start_2_Promotion from "./partPromotion/acquisition/Start_2_Promotion";
import Start_3_Promotion from "./partPromotion/acquisition/Start_3_Promotion";
import Start_4_Promotion from "./partPromotion/acquisition/Start_4_Promotion";
import FullPageWithHeaderAndProgress from "../container/FullPageWithHeaderAndProgress";
import Curriculum_1_Promotion from "./partPromotion/curriculum/Curriculum_1_Promotion";
import PaymentContentPromotion from "../../components/task/payment/PaymentContentPromotion";
import NicknameSubmitPromotion from "./partPromotion/nickname/NicknameSubmitPromotion";
import CrossFunnel_Loading_Promotion from "./partPromotion/crossFunnel/CrossFunnel_Loading_Promotion";

interface OnboardingStep {
  type: string;
  seqByType: number;
  title?: string;
  hideHeader?: boolean;
  hideProgress?: boolean;
  disableBack?: boolean;
  progressDelta?: number;
  centerFullScreen?: boolean;
  backgroundColor?: string;
  content: React.ReactNode;
}

const commonPrefixSteps: OnboardingStep[] = [
  {
    type: "start",
    seqByType: 1,
    disableBack: true,
    hideHeader: true,
    hideProgress: true,
    content: <Start_1_Promotion />,
  },
  {
    type: "start",
    seqByType: 2,
    hideProgress: true,
    content: <Start_2_Promotion />,
  },
  {
    type: "start",
    seqByType: 3,
    hideProgress: true,
    content: <Start_3_Promotion />,
  },
  {
    type: "start",
    seqByType: 4,
    hideProgress: true,
    content: <Start_4_Promotion />,
  },
];

const commonPrefixTestTypeBSteps: OnboardingStep[] = [
  {
    type: "start",
    seqByType: 1,
    disableBack: true,
    hideProgress: true,
    content: <Start_4_Promotion />,
  },
];

const demographicSteps: OnboardingStep[] = [
  {
    type: "demographic",
    seqByType: 1,
    title: "기본 정보",
    progressDelta: 1 / 4,
    disableBack: true,
    content: <Demographic_1_Promotion />,
  },
  {
    type: "demographic",
    seqByType: 2,
    title: "기본 정보",
    progressDelta: 2 / 4,
    content: <Demographic_2_Promotion />,
  },
  {
    type: "demographic",
    seqByType: 3,
    title: "기본 정보",
    progressDelta: 3 / 4,
    content: <Demographic_3_Promotion />,
  },
  {
    type: "demographic",
    seqByType: 4,
    title: "기본 정보",
    progressDelta: 4 / 4,
    content: <Demographic_4_Promotion />,
  },
];

const demographicTestTypeBSteps: OnboardingStep[] = [
  {
    type: "auth-loading",
    seqByType: 1,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <CrossFunnel_Loading_Promotion />,
  },
  {
    type: "nickname",
    seqByType: 1,
    disableBack: true,
    hideProgress: true,
    content: <NicknameSubmitPromotion />,
  },
  {
    type: "demographic",
    seqByType: 2,
    hideProgress: true,
    content: <Demographic_2_Promotion />,
  },
  {
    type: "demographic",
    seqByType: 3,
    hideProgress: true,
    content: <Demographic_3_Promotion />,
  },
  {
    type: "demographic",
    seqByType: 4,
    hideProgress: true,
    content: <Demographic_4_Promotion />,
  },
];

const mainContentSteps: OnboardingStep[] = [
  {
    type: "goal",
    seqByType: 1,
    title: "고민과 목표",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Goal_1_Promotion />,
  },
  {
    type: "goal",
    seqByType: 2,
    title: "고민과 목표",
    progressDelta: 2 / 7,
    content: <Goal_2_MultiSelect_1_Promotion />,
  },
  {
    type: "goal",
    seqByType: 3,
    title: "고민과 목표",
    progressDelta: 3 / 7,
    content: <Goal_3_MultiSelect_2_Promotion />,
  },
  {
    type: "goal",
    seqByType: 4,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_4_Promotion />,
  },
  {
    type: "goal",
    seqByType: 5,
    title: "고민과 목표",
    progressDelta: 4 / 7,
    content: <Goal_5_Promotion />,
  },
  {
    type: "goal",
    seqByType: 6,
    title: "고민과 목표",
    progressDelta: 5 / 7,
    content: <Goal_6_Promotion />,
  },
  {
    type: "goal",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_7_Promotion />,
  },
  {
    type: "goal",
    seqByType: 8,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_8_Promotion />,
  },
  {
    type: "goal",
    seqByType: 9,
    title: "고민과 목표",
    progressDelta: 6 / 7,
    content: <Goal_9_Promotion />,
  },
  {
    type: "goal",
    seqByType: 10,
    hideProgress: true,
    content: <Goal_10_Promotion />,
  },
  {
    type: "goal",
    seqByType: 11,
    hideHeader: true,
    hideProgress: true,
    content: <Goal_11_Promotion />,
  },
  {
    type: "goal",
    seqByType: 12,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_12_Promotion />,
  },
  {
    type: "convention",
    seqByType: 1,
    title: "인식과 기대",
    disableBack: true,
    progressDelta: 1 / 12,
    content: <Convention_1_Promotion />,
  },
  {
    type: "convention",
    seqByType: 2,
    title: "인식과 기대",
    progressDelta: 1 / 12,
    content: <Convention_2_QnA_Promotion />,
  },
  {
    type: "convention",
    seqByType: 3,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Convention_3_Promotion />,
  },
];

const habitContentSteps: OnboardingStep[] = [
  {
    type: "habit",
    seqByType: 1,
    title: "습관과 노력",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Habit_1_Promotion />,
  },
  {
    type: "habit",
    seqByType: 2,
    title: "습관과 노력",
    progressDelta: 1 / 7,
    content: <Habit_2_QnA_Promotion />,
  },
  {
    type: "habit",
    seqByType: 3,
    hideProgress: true,
    content: <Habit_3_Promotion />,
  },
  {
    type: "habit",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Habit_4_Promotion />,
  },
  {
    type: "habit",
    seqByType: 5,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_5_Promotion />,
  },
  {
    type: "habit",
    seqByType: 6,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_6_Promotion />,
  },
  {
    type: "habit",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_7_Promotion />,
  },
];

const habitContentTestTypeBSteps: OnboardingStep[] = [
  {
    type: "habit",
    seqByType: 1,
    title: "습관과 노력",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Habit_1_Promotion />,
  },
  {
    type: "habit",
    seqByType: 2,
    title: "습관과 노력",
    progressDelta: 1 / 7,
    content: <Habit_2_QnA_Promotion />,
  },
  {
    type: "habit",
    seqByType: 3,
    hideProgress: true,
    content: <Habit_3_Promotion />,
  },
  {
    type: "habit",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Habit_4_Promotion />,
  },
  {
    type: "habit",
    seqByType: 5,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_5_Promotion />,
  },
];

const motivationContentSteps: OnboardingStep[] = [
  {
    type: "motivation",
    seqByType: 1,
    title: "의지와 동기",
    disableBack: true,
    progressDelta: 1 / 6,
    content: <Motivation_1_Promotion />,
  },
  {
    type: "motivation",
    seqByType: 2,
    title: "의지와 동기",
    progressDelta: 2 / 6,
    content: <Motivation_2_Promotion />,
  },
  {
    type: "motivation",
    seqByType: 3,
    title: "의지와 동기",
    progressDelta: 3 / 6,
    content: <Motivation_3_Promotion />,
  },
  {
    type: "motivation",
    seqByType: 4,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_4_Promotion />,
  },
  {
    type: "motivation",
    seqByType: 5,
    title: "의지와 동기",
    progressDelta: 4 / 6,
    content: <Motivation_5_Promotion />,
  },
  {
    type: "motivation",
    seqByType: 6,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_6_Promotion />,
  },
  {
    type: "motivation",
    seqByType: 7,
    title: "의지와 동기",
    progressDelta: 5 / 6,
    content: <Motivation_7_MultiSelect_Promotion hideNextButton={false} />,
  },
  {
    type: "motivation",
    seqByType: 8,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_8_Promotion />,
  },
];

const resultSteps: OnboardingStep[] = [
  {
    type: "result",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Result_1_Promotion />,
  },
  {
    type: "result",
    seqByType: 2,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Surface.Highlight,
    content: <Result_2_Promotion />,
  },
  {
    type: "result",
    seqByType: 3,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Result_3_Promotion />,
  },
  {
    type: "result",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Result_4_Promotion />,
  },
  {
    type: "curriculum",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.Level3,
    content: <Curriculum_1_Promotion />,
  },
  {
    type: "product",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
  {
    type: "payment",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
];

function findIndexByStepInfo(
  steps: OnboardingStep[],
  type: string,
  seqByType: number
): number {
  return steps.findIndex(
    (step) => step.type === type && step.seqByType === seqByType
  );
}

export default function OnboardingScreenPromotion() {
  const { type, id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const webTestType = useRecoilValue(webTestTypeAtom);
  const isLoading = !webTestType;

  const steps = useMemo(() => {
    if (webTestType?.type === "b") {
      return [
        ...commonPrefixTestTypeBSteps,
        ...mainContentSteps,
        ...habitContentTestTypeBSteps,
        ...motivationContentSteps,
        ...resultSteps,
        ...demographicTestTypeBSteps,
      ];
    }

    if (webTestType?.type === "c") {
      return [
        ...commonPrefixSteps,
        ...mainContentSteps,
        ...habitContentSteps,
        ...motivationContentSteps,
        ...resultSteps,
        ...demographicTestTypeBSteps,
      ];
    }
    return [
      ...commonPrefixSteps,
      ...demographicSteps,
      ...mainContentSteps,
      ...habitContentSteps,
      ...motivationContentSteps,
      ...resultSteps,
    ];
  }, [webTestType?.type]);

  const numId = parseInt(id || "0");
  const questionNumber = searchParams.get("q");

  const currentStepIndex = Math.min(
    Math.max(findIndexByStepInfo(steps, type!!, numId), 0),
    steps.length - 1
  ); // 유효한 범위 내로 제한

  const currentStep = steps[currentStepIndex];
  const prevStepIndex = usePrevious(currentStepIndex);

  const trackingParams = useMemo(
    () => ({
      type: `${currentStep.type}`,
      pageId: `${currentStep.seqByType}`,
    }),
    [currentStep.type, currentStep.seqByType]
  );

  const trackPromotion = useMixpanelMKT({
    eventName: "온보딩 페이지 진입",
    params: trackingParams,
    version: "v4",
  });

  useEffect(() => {
    localStorage.removeItem("ONBOARDING_TYPE");
  }, []);

  useEffect(() => {
    if (type === "load") return;
    if (type === "auth-loading") return;
    if (type === "curriculum") return;
    if (type === "product") return;
    if (type === "payment") return;

    // 이벤트 전송
    trackPromotion();
  }, [type, id]);

  // 마지막으로 본 페이지 저장 (load/start/product 제외)
  useEffect(() => {
    if (!type || !id) return;
    // start 페이지 진입 시에는 직전에 보던 페이지로 리다이렉트해야 하므로,
    // start 자체를 마지막 페이지로 저장하지 않는다. (load/product도 제외)
    if (
      type === "load" ||
      type === "start" ||
      type === "auth-loading" ||
      type === "demographic"
    )
      return;
    try {
      writeLastStep({
        type,
        seqByType: parseInt(id, 10),
        q: questionNumber ? parseInt(questionNumber, 10) : undefined,
      });
    } catch (e) {
      // noop
    }
  }, [type, id, questionNumber]);

  // /promotion-onboarding/start/1 진입 시 마지막으로 보던 페이지로 복구
  useEffect(() => {
    if (type !== "start" || id !== "1") return;

    // 뒤로 가기(인덱스가 감소)해서 도달한 경우에는 리다이렉트 하지 않음
    if (
      prevStepIndex !== undefined &&
      (prevStepIndex as number) > currentStepIndex
    ) {
      return;
    }

    try {
      const parsed = readLastStep();
      // 유효성 체크: steps 내 존재 여부 확인
      if (!parsed) return;
      const idx = findIndexByStepInfo(steps, parsed.type, parsed.seqByType);
      if (idx < 0) return;
      const query = parsed.q ? `?q=${parsed.q}` : "";
      const targetPath = `/promotion-onboarding/${parsed.type}/${parsed.seqByType}${query}`;
      // 이미 동일한 경로면 무시
      const currentPath = `/promotion-onboarding/${type}/${id}${questionNumber ? `?q=${questionNumber}` : ""}`;
      if (currentPath === targetPath) return;
      navigate(targetPath, { replace: true });
    } catch (e) {
      // 파싱 실패 등은 무시
    }
  }, [
    type,
    id,
    questionNumber,
    steps,
    navigate,
    prevStepIndex,
    currentStepIndex,
  ]);

  const handleBack = () => {
    if (currentStepIndex <= 0) return;
    if (
      webTestType?.type === "b" &&
      currentStep.type === "demographic" &&
      currentStep.seqByType === 2
    ) {
      navigate("promotion-onboarding/nickname/1", { replace: true });
      return;
    }

    if (
      (currentStep.type === "convention" || currentStep.type === "habit") &&
      currentStep.seqByType === 2
    ) {
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 1) {
        const prevQuestion = parseInt(questionNumber!!) - 1;
        navigate(
          `/promotion-onboarding/${currentStep.type}/${currentStep.seqByType}?q=${prevQuestion}`,
          { replace: true }
        );
      } else {
        const prevStep = steps[currentStepIndex - 1];
        navigate(
          `/promotion-onboarding/${prevStep.type}/${prevStep.seqByType}`,
          { replace: true }
        );
      }
      return;
    }

    if (currentStep.type === "convention" && currentStep.seqByType === 3) {
      navigate(
        `/promotion-onboarding/${currentStep.type}/${currentStep.seqByType - 1}?q=10`,
        { replace: true }
      );
      return;
    }

    if (currentStep.type === "habit" && currentStep.seqByType === 3) {
      navigate(
        `/promotion-onboarding/${currentStep.type}/${currentStep.seqByType - 1}?q=5`,
        { replace: true }
      );
      return;
    }

    const prevStep = steps[currentStepIndex - 1];
    navigate(`/promotion-onboarding/${prevStep.type}/${prevStep.seqByType}`, {
      replace: true,
    });
  };

  const { setProgress, setSectionCount } = useOnboardingProgress();

  useEffect(() => {
    if (currentStep.progressDelta) {
      let ratio = 1;
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 0) {
        ratio = parseInt(questionNumber!!);
      }

      if (webTestType?.type === "a") {
        // 5개 섹션, 각 20%
        setSectionCount(5);
        if (currentStep.type === "demographic") {
          setProgress(0 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "goal") {
          setProgress(20 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "convention") {
          setProgress(40 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "habit") {
          setProgress(60 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "motivation") {
          let progress = 80 + 20 * currentStep.progressDelta * ratio;
          setProgress(Math.min(progress, 100)); // 100을 넘지 않도록
        }
      } else {
        // 4개 섹션, 각 20%
        setSectionCount(4);
        if (currentStep.type === "goal") {
          setProgress(0 + 25 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "convention") {
          setProgress(25 + 25 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "habit") {
          setProgress(50 + 25 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "motivation") {
          let progress = 75 + 25 * currentStep.progressDelta * ratio;
          setProgress(Math.min(progress, 100)); // 100을 넘지 않도록
        }
      }
    }
  }, [currentStep, questionNumber, setProgress, webTestType?.type]);

  if (isLoading) {
    return (
      <FullPageWithCenterContentV2
        content={
          <Box
            sx={{
              display: "flex",
              height: "100vh",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor:
                currentStep?.backgroundColor !== undefined
                  ? currentStep?.backgroundColor
                  : theme.vars.palette.Background.Level1,
            }}
          >
            <CircularProgress color="neutral" />
          </Box>
        }
        backgroundColor={currentStep?.backgroundColor}
      />
    );
  }

  if (currentStep.type === "payment") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<PaymentContentPromotion />}
      </div>
    );
  }

  if (currentStep.type === "product") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<ProductContentPromotion />}
      </div>
    );
  }

  return currentStep.centerFullScreen === true ? (
    <FullPageWithCenterContentV2
      content={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
    />
  ) : (
    <FullPageWithHeaderAndProgress
      headerTitle={currentStep.title}
      hideHeader={currentStep.hideHeader}
      hideProgress={currentStep.hideProgress}
      body={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
      disableBack={currentStep.disableBack}
      onBack={currentStepIndex > 0 ? handleBack : undefined} // 첫 번째 단계에서는 뒤로가기 버튼 숨김
    />
  );
}
